<span class="close-modal-outside"><i (click)="ActiveModal.dismiss()" class="im-icon im-icon-x-light"></i></span>
<div class="modal-wrap">
  @if (!ready || !resourcesReady) {
    <app-spinner [centerVertically]="true"></app-spinner>
  }
  @if (selection) {
    <div class="d-flex detail-modal selection-detail-modal">
      <!-- side panel -->
      @if (uuid) {
        <app-modal-side-panel [open]="true">
          <div class="d-flex flex-column w-100 flex-grow-1 scroll-y pb-5">
            <div class="p-l pb-s panel-head">
              <button (click)="ActiveModal.dismiss()" [class.disabled]="saving" class="mb-xl fontsize-xs"> <i class="im-icon im-icon-arrow-left mr-0" style="font-size: 18px;"></i> <span class="fontsize-s d-inline-block" style="margin-left: 11px;line-height: 21px;transform: translateY(-2px);">Terug naar overzicht</span></button>
              <div class="">
                <div class="d-flex flex-column titles">
                  <span class="title">
                    {{uuid ? selection.name : 'Nieuwe selectie'}}
                  </span>
                </div>
              </div>
            </div>
            <div class="d-flex flex-grow-1 scroll-y" [class.saving]="loading">
              <app-side-navigation
                class="d-block w-100"
                [pageARR]="pages"
                [model]="activePage"
                (modelChange)="pageChange($event)"
                [subscriptionAmountSpinner]="subscriptionAmountSpinner"
                [subscriptionAmount]="subscriptionAmount">
              </app-side-navigation>
            </div>
          </div>
        </app-modal-side-panel>
      }
      <!-- start form -->
      <div class="d-flex flex-column w-100 flex-grow-1 scroll-y" [class.pb-5]="getActivePage().code !== 'preview'">
        <div class="">
          <!-- header -->
          <div class="detail-modal-header d-flex flex-row justify-content-between align-items-center" style="min-height: 36px;">
            <h1 style="min-height: 36px;" class="d-flex align-items-center">
              <!-- <i class="active-page-icon" *ngIf="getActivePage()?.icon" class="im-icon im-icon-{{getActivePage().icon}}"></i> -->
              <span>@if (!uuid) {
                Nieuwe selectie
                }@if (uuid) {
                {{getActivePage().name}}
              }</span>
            </h1>
            @if (!sectionIsActive('conditions')) {
              <div class="h-100 d-flex align-items-center">
                <!-- edit -->
                @if (canDelete('conditions') && activePage == 'conditions') {
                  <button class="button tertiary ml-xs" (click)="activeSection = 'conditions';setSideNavDisabled(true);" [class.disabled]="saving || !canEdit('conditions')"><i class="im-icon im-icon-pencil icon-l mr-xxxs"></i><span>Wijzig</span></button>
                }
              </div>
            }
            @if (sectionIsActive('conditions')) {
              <div class="h-100 d-flex align-items-center">
                <!-- cancel -->
                @if (!lastPageActive()) {
                  <button class="button tertiary" (click)="canExit() && (uuid ? activeSection = null : ActiveModal.dismiss()); resetForm();setSideNavDisabled(false);" [class.disabled]="saving"><span>Annuleer</span></button>
                }
                <!-- submit -->
                <!-- <button *ngIf="!lastPageActive()" class="button default ml-xs" (click)="createUpdateSelection();" [class.disabled]="saving">Bewaar</button> -->
                @if (!lastPageActive()) {
                  <app-button classes="primary-default ml-xs" icon="check-round-filled" text="Bewaar" [disabled]="saving" [submitting]="submitting" (emitClick)="createUpdateSelection()"></app-button>
                }
              </div>
            }
          </div>
          @if (loading) {
            <div style="height: 100%;">
              <app-spinner [centerVertically]="true"></app-spinner>
            </div>
          }
          @if (!loading) {
            <div class="detail-modal-body">
              <!--------- CONDITIONS --------->
              @if (activePage == 'conditions') {
                <div>
                  <div class="row display-row mw-600-px">
                    <div class="col-12">
                      <!-- name -->
                      <div class="display-content">
                        @if (!sectionIsActive('conditions')) {
                          <div class="display-label" [class.text-color]="sectionIsActive('conditions')">Naam selectie</div>
                          <div class="display-value d-flex flex-row">
                            <span>{{selection.name | display}}</span>
                          </div>
                        }
                        @if (sectionIsActive('conditions')) {
                          <app-field-text
                            [model]="formSTR.name"
                            (modelChange)="formSTR.name = $event;"
                            label="Naam selectie"
                            [error]="validation.name"
                            placeholder="">
                          </app-field-text>
                        }
                      </div>
                    </div>
                  </div>
                  @if (formSTR.type == 'dynamic') {
                    <div class="conditions mw-600-px">
                      @if (!sectionIsActive('conditions')) {
                        <div class="display-row--">
                          <div class="display-label">Voorwaarden</div>
                          <ol class="display-value">
                            @for (condition of selection.conditionARR; track condition) {
                              <li>
                                <div class="values">
                                  <span class="fontweight-500">{{condition.condition}}</span>
                                  <ul>
                                    @for (value of condition.valueARR; track value) {
                                      <li>
                                        <div class="arrow-right"></div>{{value}}
                                      </li>
                                    }
                                  </ul>
                                </div>
                              </li>
                            }
                          </ol>
                        </div>
                      }
                      @if (sectionIsActive('conditions')) {
                        <div class="fontsize-l mb-xxxs">Voorwaarden</div>
                        <span class="passive-gray fontsize-s">Bouw je selectie op door bijkomende voorwaarden toe te voegen</span>
                        @for (condition of formSTR.conditionARR; track condition; let $i = $index) {
                          <div class="row mt-s mw-1200-px">
                            <div class="col-5">
                              <div class="position-relative select-wrap">
                                <app-field-select
                                  [model]="formSTR.conditionARR[$i].condition"
                                  [options]="conditionOptions"
                                  (modelChange)="formSTR.conditionARR[$i].condition = $event;setConditionOptionOptions($i); formChange();"
                                  label="Voorwaarde"
                                  [error]="validation.condition"
                                  placeholder="Selecteer..."
                                  [disabled]="$i == 0 ? true : false"
                                  [excludeValues]="$i !== 0 ? getTestCondition() : []">
                                </app-field-select>
                                <!-- <i (click)="deleteCondition($i)" class="icon icon-delete alignToSelect" *ngIf="(formSTR.conditionARR.length > 1 && !showIfConditionSelected($i)) && $i > 0"></i> -->
                                @if ((formSTR.conditionARR.length > 1 && !showIfConditionSelected($i)) && $i > 0) {
                                  <i (click)="deleteCondition($i)" class="im-icon im-icon-x-light" ></i>
                                }
                              </div>
                            </div>
                            @if (showIfConditionSelected($i)) {
                              <div  [ngClass]="getColWidth($i)">
                                @for (value of formSTR.conditionARR[$i].valueARR; track identify($j, value); let $j = $index) {
                                  <div [ngClass]="(showIfConditionSelected($i) && hasSingleValue($i)) ? 'mb-s' : ''" class=" position-relative select-wrap">
                                    @if (showFieldByType($i, 'dropdown')) {
                                      <app-field-select
                                        [model]="formSTR.conditionARR[$i].valueARR[$j]"
                                        [options]="selectedConditionOptions[$i]"
                                        (modelChange)="formSTR.conditionARR[$i].valueARR[$j] = $event; formChange();"
                                        [label]="$j === 0 ? 'Waarde' : ''"
                                        [error]="validation[formSTR.conditionARR[$i].condition]"
                                        placeholder="Selecteer...">
                                      </app-field-select>
                                    }
                                    @if (showFieldByType($i, 'text')) {
                                      <app-field-text
                                        [model]="formSTR.conditionARR[$i].valueARR[$j]"
                                        (modelChange)="formSTR.conditionARR[$i].valueARR[$j] = $event; formChange();"
                                        [label]="$j === 0 ? 'Waarde' : ''"
                                        [error]="validation.value"
                                        placeholder="">
                                      </app-field-text>
                                    }
                                    @if (showFieldByType($i, 'autocomplete')) {
                                      <app-field-typeahead-small
                                        [index]="$j"
                                        [initialModel]="formSTR.conditionARR[$i].initialValueARR[$j]"
                                        (modelChange)="formSTR.conditionARR[$i].valueARR[$j] = $event ? $event.item.key : ''; formChange();formSTR.conditionARR[$i].initialValueARR[$j] = $event ? {key: $event.item.key, value: $event.item.value} : {};"
                                        [options]="productARR"
                                        [searchKeyARR]="['value','code']"
                                        [afterARR]="['productType','artikelCode']"
                                        [editable]="false"
                                        [label]="$j === 0 ? 'Waarde' : ''"
                                        [error]="validation.value"
                                        placeholder="">
                                      </app-field-typeahead-small>
                                    }
                                    @if (showIfConditionSelected($i) && (formSTR.conditionARR[$i].valueARR.length > 1 || $i > 0)) {
                                      <i (click)="deleteValue($i, $j)" class="im-icon im-icon-x-light" ></i>
                                    }
                                  </div>
                                }
                                @if (showIfConditionSelected($i) && hasSingleValue($i)) {
                                  <div>
                                    <button (click)="addValue($i)" class="button-link mt-xs fontsize-s">
                                      <i class="im-icon im-icon-plus"></i>
                                      <span>Voeg waarde toe</span>
                                    </button>
                                  </div>
                                }
                              </div>
                            }
                            <div class="col-12">
                              <div class="form-row-sep"></div>
                            </div>
                          </div>
                        }
                        <div class="row ">
                          <div class="col-12">
                            <button (click)="addCondition()" class="button-link mt-s fontsize-s">
                              <i class="im-icon im-icon-plus"></i>
                              <span>Voeg voorwaarde toe</span>
                            </button>
                          </div>
                        </div>
                        <div class=""></div>
                      }
                    </div>
                  }
                </div>
              }
              <!--------- LIST --------->
              @if (activePage == 'list') {
                <div>
                  <app-table
                    [heads]="tableHeads"
                    [data]="listARR"
                    [sort]=""
                    [RPP]="RPP"
                    [startRow]="startRow"
                    [totalRows]="totalRows"
                    [loading]="tableLoading"
                    [shimmerTypes]="['text-m','text-m','text-sm','text-m','actions']"
                    emptyState="Geen resultaten"
                    (sortChange)="false"
                    (clickData)="false"
                    (clickAction)="actionClick($event.item, $event.action)"
                    (startRowChange)="false"
                    [canAddRows]="formSTR.type == 'static' && sectionIsActive('conditions') ? true : false"
                    (addRowToTable)="addRowToTable($event)"
                    [addRowFormSTR]="addRowFormSTR"
                    (startRowChange)="changeStartRow($event)"
                    >
                  </app-table>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>